import type { IconSvgObject } from './types';

const TextSuperscriptIcon: IconSvgObject = [
  ["path", { d: "M11.5 21H6.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9 3L9 21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M2 5.5V4C2 3.44772 2.44772 3 3 3H15C15.5523 3 16 3.44772 16 4V5.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M22 12H18C18 9.77899 22 9.88544 22 7.5C22 6.67157 21.1046 6 20 6C18.8954 6 18 6.67157 18 7.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default TextSuperscriptIcon;
